"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ePlatformType;
(function (ePlatformType) {
    ePlatformType["vkvideo"] = "vkvideo";
    ePlatformType["rutube"] = "rutube";
    ePlatformType["ok"] = "ok";
})(ePlatformType || (ePlatformType = {}));
exports.default = ePlatformType;
